import { fork } from 'redux-saga/effects';
import { watchActions } from './MasterSaga';
import { watchUserActions } from './UserSaga';
import { watchMetadataActions } from './MetadataSaga';
import { watchOrganizationActions } from './OrganizationSaga';
import { watchCommunicationActions } from './CommunicationSaga';

export default function* root() {
    yield fork(watchActions);
    yield fork(watchUserActions);
    yield fork(watchMetadataActions);
    yield fork(watchOrganizationActions);
    yield fork(watchCommunicationActions);
}